export default "__VITE_ASSET__DtbjCzFo__"